<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12 text-center">
      <div class="container">
        <div class="text-center" style="margin-top:5%">
          <h2>THANK YOU FOR SUBMITTING YOUR INFORMATION</h2>
          <br />
          <p style="font-weight:bold">Right click anywhere on the page and select Print</p>
          <br />
        </div>
        <p>
          <b>This screen is your formal receipt and no email receipt will be sent, to retain a copy for your records, right click anywhere on the page and select Print.</b><br /><br />

          Your Reference Number is <b>11541REF{{claimant.claimNumber}}</b>. The information was submitted on <b>{{claimant.dateCreated | date:'mediumDate'}}</b>.
          Payments from the Settlements will be made only if the Court approves the Settlement and only after any appeals are resolved.
          Please be patient.
        </p>
        <br />

        <div class="row">
          <div class="col-md-12 text-center">
            <a href="https://floridanationstarlawsuit.com/" class="btn btn-primary">Exit to Return to the Settlement Website</a>
          </div>
          <br />
          <br />
          <br />
        </div>
      </div>

    </div>
  </div>
  <br /><br />
</div>

<!--<br />
<br />
<div class="row">
  <div class="col-md-12">
    <h5>******The Information Below Is For Internal Purposes Only, This Is What Was Saved To The Database******</h5><br />
    <pre>Form Data: {{claimant | json}}</pre>
  </div>
</div>-->
